import React from 'react';
import { useOfferContext } from '../../../context';
import { SeoSuggestion } from '../../../components/SeoSuggestion';

export const SeoSuggestionContainer: React.FC = () => {
  const { currentPath, seoSuggestionLabel, seoSuggestionDistance } = useOfferContext();

  if (!seoSuggestionLabel) {
    return null;
  }

  return <SeoSuggestion text={seoSuggestionLabel} distance={seoSuggestionDistance} url={currentPath} />;
};
